<template>
  <div class="mm-page-main"   v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div class="page-header">
      <div class="page-title">部門管理</div>
      <el-link @click="gotoruter('/AddSector')" type="primary"><i class="el-icon-circle-plus"></i>添加部門</el-link>
    </div>

    <div v-if="sectors.length>0" class="mm-tabs">
      <div class="mm-tabsulbox">
        <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
        <ul :style="transform" class="mm-tabs-card">
          <li @click.stop="changesector(sector.id)" :class="{active:sector_id == sector.id}" v-for="(sector,index) in sectors" :key="index">{{sector.name}}
          </li>
        </ul>
        <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="mm-tabs-content">
        <div class="mm-tab-hedaer">
          <div class="mm-tab-title">
            <h3>員工列表</h3>
          </div>
          <div>
            <el-button @click="editsector()" class="text-white">編輯部門</el-button>
            <el-button @click="openchooseuser()" type="primary" class="text-white">導入員工</el-button>
            <el-dialog @closed="closechooseuser" title="導入員工" :visible.sync="chooseuser" width="95%" :append-to-body="true">
              <component @closedialog="closedialog" :sector_id="sector_id" :is="chooseuser_component"></component>
            </el-dialog>
          </div>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="userdata" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="username" label="用戶名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">用戶名</div>
                <div>{{scope.row.username}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">姓名</div>
                <div>{{scope.row.name}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="郵箱" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">郵箱</div>
                <div>{{scope.row.email}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="電話" align="center" sortable>
              <template slot-scope="scope">
                <div class="phonecel">電話</div>
                <div>{{scope.row.phone}}</div>
              </template>
            </el-table-column>
            <el-table-column sortable prop="sex" label="性別" align="center">
              <template slot-scope="scope">
                <div class="phonecel">性別</div>
                <div v-if="scope.row.sex == 0">男</div>
                <div v-else>女</div>
              </template>

            </el-table-column>
            <!-- <el-table-column sortable prop="age" label="年齡" align="center">
              <template slot-scope="scope">
                <div class="phonecel">年齡</div>
                <div>{{scope.row.age}}</div>
              </template>
            </el-table-column> -->
            <el-table-column sortable prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <div v-if="scope.row.status == 0">啟用</div>
                <div v-else>禁用</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <el-button @click="getout(scope.row.user_id)" size="mini">剔除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import chooseuser from "./components/chooseuser.vue";
export default {
  components: {
    chooseuser
  },
  data () {
    return {
      mso_id:0,
      loading: false,
      chooseuser: false,
      sector_id: 0,
      sectors: [],
      transform: '',
      transformnum: 0,
      userdata: [],
      chooseuser_component: '',
    }
  },
  methods: {
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.sectors.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    editsector () {

      this.$router.push({
        name: '/EditSector',
        path: '/EditSector',
        params: {
          id: this.sector_id
        }
      })
    },
    closedialog () {
      this.chooseuser = false;
      this.chooseuser_component = '';
      this.sectoruser();
    },
    closechooseuser () {
      this.chooseuser = false;
      this.chooseuser_component = '';
      this.sectoruser();
    },
    openchooseuser () {
      this.chooseuser = true;
      this.chooseuser_component = chooseuser;
    },
    sectoruser () {
      this.loading = true;
      this.post('/api/sector/sectoruser', {
        sector_id: this.sector_id
      }).then((res) => {
        this.loading = false;
        this.userdata = res;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    getout (user_id) {
      this.loading = true;
      let sector_id = this.sector_id;
      this.post('/api/sector/getout', {
        sector_id: sector_id,
        user_id: user_id
      }).then((res) => {

        this.sectoruser();
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    changeoffice (office_id) {
      this.office_id = office_id;
      this.getsector();
    },
    changesector (sector_id) {
      this.sector_id = sector_id;
      this.sectoruser();
    },

    gotoruter (name) {
      this.$router.push(name)
    },
    getsector () {
      this.loading = true;
      let mso_id = this.sessionRead('mso_id');
      this.post('/api/sector/index', {
        mso_id:mso_id,
      }).then((res) => {
        if (res.length > 0) {
          this.sector_id = res[0].id;
        }
        this.sectors = res;
        this.loading = false;

      }).catch((err) => {
        this.loading = false;
        console.log(err)
      }).then(() => {
        this.sectoruser();
      })


    },

  },
  created () {
    this.mso_id = this.sessionRead('mso_id');
    this.getsector();
  }
}
</script>

<style scoped>
</style>
